import React, {PureComponent} from 'react'
import cn from "classnames"
import injectSheet from 'react-jss'
import RichTextContainer from "../Widgets/RichTextContainer"
import CentredContentContainer from "../Widgets/CentredContentContainer"

const RIGHT_TEXT_PLACEMENT = 'Right'
const isTextRightPlacement = ({item: {text_placement}}) => text_placement === RIGHT_TEXT_PLACEMENT

class YouTubeContent extends PureComponent {

    render() {
        const {classes, item} = this.props;
        const {youtube_video_link, text} = item;

        if(!text) {
            return <section>
                <CentredContentContainer size="huge" extended={true} className={classes.container} >
                    <div className={classes.videoWrapper} dangerouslySetInnerHTML={{__html: youtube_video_link.html}}></div>
                </CentredContentContainer>
            </section>
        }

        return <section>
            <CentredContentContainer extended={true} size="huge" className={classes.containerWithText} >
                <div className={cn(classes.videoContainer)}>
                    <div className={classes.videoWrapper} dangerouslySetInnerHTML={{__html: youtube_video_link.html}}></div>
                </div>
                <RichTextContainer className={classes.textContainer} content={text} removeBottomMargin={true} />
            </CentredContentContainer>
        </section>
    }
}

export default injectSheet((theme) => (
{
    container: {
        //display: "flex",
    },
    containerWithText: {
        display: "flex",
        flexDirection: "column",
        [theme.breakpoint("laptop")]: {
            flexDirection: (props) => isTextRightPlacement(props) ? 'row-reverse' : 'row',
            paddingLeft: (props) => isTextRightPlacement(props) ? null : 0,
            paddingRight: (props) => isTextRightPlacement(props) ? 0 : null,
        }
    },
    textContainer: {
        flexBasis: "50%",
        [theme.breakpoint("laptop", "max")]: {
            maxWidth: theme.content.widthLarge,
            width: "auto",
            padding: `0 ${theme.spacing.tiny}`,
            marginLeft: 0,
            marginRight: 0,
        },
        [theme.breakpoint("mobile")]: {
            marginLeft: `-${theme.spacing.small}`,
            marginRight: `-${theme.spacing.small}`,
        },
        [theme.breakpoint("tablet")]: {
            marginLeft: `-${theme.spacing.large}`,
            marginRight: `-${theme.spacing.large}`,
        },
        [theme.breakpoint("laptop")]: {
            maxWidth: (theme.content.width - ((theme.content.widthLarge - theme.content.width)/2))/2,
            width: "auto",
            padding: 0,
            marginLeft: (props) => isTextRightPlacement(props) ? 0 : theme.spacing.normal,
            marginRight: (props) => isTextRightPlacement(props) ? theme.spacing.normal : 0,
        }
    },
    videoContainer: {
        flexBasis: "50%",
        marginBottom: `${theme.base.lineHeight/2}rem`,
        [theme.breakpoint("laptop")]: {
            margin: 0,
        }
    },
    videoWrapper: {
        position: "relative",
        paddingBottom: "56.25%", // 16:9
        //paddingTop: 25px;
        height: 0,
        "& iframe": {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
        }
    },
}
))(YouTubeContent)



// WEBPACK FOOTER //
// ./src/components/Article/YouTubeContent.js